//  ----------      START   IMPORT  BLOCK       ----------
import { useMemo, useCallback } from 'react';
// Context
import { useActivePatient } from './ActivePatientContext';
//  ----------      END   IMPORT  BLOCK       ----------

export const useUserDiagnoses = () => {
  const { activePatient } = useActivePatient();

  // 1. Extract the raw diagnoses list from activePatient.diagnoses.diagnoses
  const diagnosesList = useMemo(() => {
    return activePatient?.diagnoses?.diagnoses ?? [];
  }, [activePatient]);

  // 2. Extract contained CIE affections/tags metadata
  const containedAffections = useMemo(() => {
    return activePatient?.diagnoses?.contained_affections ?? [];
  }, [activePatient]);

  // 3. Pre-computed Map for fast O(1) CIE tag lookup by id_cie
  const tagsMap = useMemo(() => {
    return new Map(containedAffections.map((tag) => [tag.id_cie, tag.name]));
  }, [containedAffections]);

  // 4. Pre-computed grouping by year for components like YearlyDisplay
  const diagnosesByYear = useMemo(() => {
    const grouped = {};
    diagnosesList.forEach((diag) => {
      if (!diag?.creation_date) return;
      const year = new Date(diag.creation_date).getFullYear();
      if (!grouped[year]) grouped[year] = [];
      grouped[year].push(diag);
    });
    return grouped;
  }, [diagnosesList]);

  /**
  const createDiagnosisEntry = async (
    
    vitals_params, interrogatory, exploration, 
    diagnosis_param, tags_contained, laboratory_raw_text, prescription_params) => {
      const service = new UserDiagnosesService();
      const updated = await service.createDiagnosisEntry(patient.basics.username, vitals_params, interrogatory, exploration, 
    diagnosis_param, tags_contained, laboratory_raw_text, prescription_params);
     
    return
    }
  */

  /**
   * Read-only access to diagnoses list stored in context
   */
  const readUserDiagnoses = useCallback(async () => {
    return diagnosesList;
  }, [diagnosesList]);

  return {
    diagnoses: activePatient?.diagnoses, // Raw object { diagnoses: [...], contained_affections: [...] }
    diagnosesList,                       // Extracted array of diagnosis items
    containedAffections,                 // Array of CIE tag metadata
    diagnosesByYear,                     // Pre-grouped by creation year
    tagsMap,                             // Quick lookup Map for tag names
    hasDiagnoses: diagnosesList.length > 0,
    readUserDiagnoses,
  };
};